module.exports = __webpack_public_path__ + "conways_game_of_life.9ea4e47b2177921ee76f.png";